<script setup>
import OfferCard from './offer-card.vue';
import RocketIcon from "../../assets/rocket.png";
import DiamondIcon from "../../assets/diamond.png";

import {ref} from "vue";

const data = ref([
    {
        name: "Стартовый",
        sumMax: 4_500_000,
        sumProperty: 1_000_000,
        sumThirdPartyInjury: 1_000_000,
        sumTenant: 2_500_000,
        price: 30_000,
        icon: RocketIcon
    },
    {
        name: "Максимальный",
        sumMax: 13_500_000,
        sumProperty: 3_000_000,
        sumThirdPartyInjury: 3_000_000,
        sumTenant: 7_500_000,
        price: 60_000,
        icon: DiamondIcon
    }
])
</script>

<template>
    <div class="offers">
        <h2 class="title">{{ $t("business.offers.title") }}</h2>

        <div class="cards">
            <div v-for="item in data">
                <OfferCard
                    v-bind="item"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>
.title {
    font-size: 30px;
    max-width: 630px;
    color: #535353;
    text-transform: uppercase;
}

.offers {
    margin-top: 100px;
}

.cards {
    display: flex;
    margin-top: 50px;
    gap: 20px;
}

@media screen and (max-width: 1280px) {
    .cards {
        flex-direction: column;
        margin-top: 35px;
    }

    .offers {
        padding: 0 20px;

        margin-top: 70px;
    }
}
</style>